import axios from 'axios';

export interface EspecialidadPerfilDTO {
  id: number;
  nombre: string;
  activo: boolean;
  orden: number;
}

export interface ReferenciaEnarmEspecialidadDTO {
  id: number;
  especialidadId: number;
  especialidadNombre: string;
  anio: number;
  promedio: number;
  fuente?: string;
  activo: boolean;
}

class EspecialidadPerfilService {
  // ---- Catálogo (público autenticado) ----
  async listarActivas(): Promise<EspecialidadPerfilDTO[]> {
    const { data } = await axios.get<EspecialidadPerfilDTO[]>('/api/especialidades-perfil');
    return data;
  }

  // ---- Admin: catálogo ----
  async listarTodasAdmin(): Promise<EspecialidadPerfilDTO[]> {
    const { data } = await axios.get<EspecialidadPerfilDTO[]>('/api/admin/especialidades-perfil');
    return data;
  }

  async guardar(dto: Partial<EspecialidadPerfilDTO>): Promise<EspecialidadPerfilDTO> {
    const { data } = await axios.post<EspecialidadPerfilDTO>('/api/admin/especialidades-perfil', dto);
    return data;
  }

  async toggleActivo(id: number): Promise<EspecialidadPerfilDTO> {
    const { data } = await axios.patch<EspecialidadPerfilDTO>(`/api/admin/especialidades-perfil/${id}/toggle`);
    return data;
  }

  async eliminar(id: number): Promise<void> {
    await axios.delete(`/api/admin/especialidades-perfil/${id}`);
  }

  // ---- Admin: referencias por especialidad ----
  async listarReferenciasAdmin(): Promise<ReferenciaEnarmEspecialidadDTO[]> {
    const { data } = await axios.get<ReferenciaEnarmEspecialidadDTO[]>('/api/admin/enarm/referencias-especialidad');
    return data;
  }

  async guardarReferencia(dto: Partial<ReferenciaEnarmEspecialidadDTO>): Promise<ReferenciaEnarmEspecialidadDTO> {
    const { data } = await axios.post<ReferenciaEnarmEspecialidadDTO>('/api/admin/enarm/referencia-especialidad', dto);
    return data;
  }

  async eliminarReferencia(id: number): Promise<void> {
    await axios.delete(`/api/admin/enarm/referencia-especialidad/${id}`);
  }
}

export const especialidadPerfilService = new EspecialidadPerfilService();
export default especialidadPerfilService;
